/**
 * API de Planos.
 *
 * Replica os tipos do backend (PlanoPublico em Pydantic).
 * Quando integrarmos OpenAPI codegen, esses tipos podem vir gerados
 * automaticamente. Por enquanto, manter sincronizado manualmente.
 */
import { api } from './client';

export type NivelPlano = 'bronze' | 'prata' | 'ouro' | 'diamante';
export type ModalidadePlano = 'individual' | 'coletivo';
export type CicloPagamento = 'mensal' | 'anual';

export interface Plano {
  id: string;
  sku: string;
  nome: string;
  descricao_curta: string;
  nivel: NivelPlano;
  modalidade: ModalidadePlano;
  ciclo: CicloPagamento;
  valor_centavos: number;
  valor_total_centavos: number;
  parcelas_padrao: number;
  consultas_clinico_geral_ilimitadas: boolean;
  consultas_especialista_ano: number;
  check_up_anual: number;
  vidas_incluidas: number;
}

export const planosApi = {
  /** Lista planos. Filtros opcionais por modalidade/ciclo. */
  list: (filtros?: { modalidade?: ModalidadePlano; ciclo?: CicloPagamento }) => {
    const params = new URLSearchParams();
    if (filtros?.modalidade) params.set('modalidade', filtros.modalidade);
    if (filtros?.ciclo) params.set('ciclo', filtros.ciclo);
    const qs = params.toString();
    return api.get<Plano[]>(`/api/planos${qs ? `?${qs}` : ''}`);
  },
};

/** Formata centavos como "R$ X,XX". */
export function formatBRL(centavos: number): string {
  return (centavos / 100).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}
